/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AppointmentSettings } from './appointment-settings';
import { ServiceFormField } from './service-form-field';
/**
 * 
 * @export
 * @interface ServiceForm
 */
export interface ServiceForm {
  _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof ServiceForm
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ServiceForm
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ServiceForm
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceForm
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceForm
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceForm
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceForm
     */
    category: ServiceFormCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof ServiceForm
     */
    price: number;
    /**
     * Default service duration in minutes
     * @type {number}
     * @memberof ServiceForm
     */
    duration: number;
    /**
     * 
     * @type {Array<ServiceFormField>}
     * @memberof ServiceForm
     */
    fields: Array<ServiceFormField>;
    /**
     * 
     * @type {AppointmentSettings}
     * @memberof ServiceForm
     */
    appointment: AppointmentSettings;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceForm
     */
    isActive: boolean;
    /**
     * When true (vaccines), the questionnaire is resolved from the store shared consent template and `fields` is ignored. Set false to give this form its own custom fields.
     * @type {boolean}
     * @memberof ServiceForm
     */
    usesSharedForm: boolean;
    /**
     * Key of the catalog template this form was created from
     * @type {string}
     * @memberof ServiceForm
     */
    catalogKey?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ServiceFormCategoryEnum {
    Vaccine = 'vaccine',
    Test = 'test',
    Consultation = 'consultation',
    Treatment = 'treatment',
    Other = 'other'
}

